import { COLORS } from '@btime/constants'
import { formatDate } from '@btime/helpers'
import { compose, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../components/presentation/Text'
import { useServiceOrder } from './_load/ServiceOrderLoader'
import { useServiceOrderFastActionsList } from '../../../utils/actions/serviceOrders/fastList'
import { useServiceOrderResumeAction } from '../../../utils/actions/serviceOrders/actions'
import { useServiceOrdersActionsList } from '../../../utils/actions/serviceOrders/list'
import { useSessionPermission } from '@btime/react-session'
import DeletedTag from '../../../components/helpers/DeletedTag'
import DropdownLink from '../../../components/navigation/DropdownLink'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('serviceOrders')
  const serviceOrder = useServiceOrder()
  const resume = useServiceOrderResumeAction(serviceOrder)
  const canViewServiceOrderInternalId = useSessionPermission('canViewServiceOrderInternalId')

  const options = useServiceOrdersActionsList(serviceOrder, null, undefined, {
    hide: ['resume', 'remove']
  })

  const fastActions = useServiceOrderFastActionsList(serviceOrder, { hide: ['resume'] })

  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('insertedAt'))(serviceOrder)

  return (
    <>
      <Grid align="center" justify="flex-start" gutter={0.3}>
        <Col flex={1}>
          {canViewServiceOrderInternalId && (
            <SmallText size="xxsmall" color={COLORS.dark3}>{`#${serviceOrder.id}`}</SmallText>
          )}
          <Title size="h4" noMargin>
            {t('resume.title', { yearlyId: serviceOrder.yearlyId })}
          </Title>
          <SmallText color={COLORS.dark3}>
            {t('fields.createdAt')} {createdAt}
          </SmallText>
        </Col>
        <Col flex={1}></Col>

        <Col>
          <DeletedTag entity={serviceOrder} />
        </Col>
        <Col>
          <RefetchingIndicator />
        </Col>

        {!serviceOrder.deleted && (
          <>
            <Col>
              <IconText
                iconLeft="BsFileRichtext"
                color="dark3"
                bold
                label={t('resume.fullResume')}
                useNewTab
                path={resume.link}
                noWrap
              />
            </Col>
            <Separator vertical />

            {fastActions.map(action => (
              <>
                <Col key={action.label}>
                  <IconText iconLeft={action.icon} color="dark3" bold {...action} noWrap />
                </Col>
                <Separator vertical />
              </>
            ))}

            <Col>
              <DropdownLink
                fromRight
                options={options}
                actionContent={<Icon name="BsThreeDotsVertical" ize="1.4rem" />}
                t={t}
              />
            </Col>
          </>
        )}
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
